var collapsible_list_pair_rtlignore_default = {
  "container": "A8VCZ",
  "title": "LboBw",
  "viewerContainer": "YpQpo",
  "titleContainer": "iPexD",
  "content": "_98pY8",
  "expandIcon": "rid1E",
  "dndIcon": "_4-wTI",
  "RTL": "PABp8",
  "LTR": "_364XK",
  "itemContainer": "_15C3z",
  "itemContainerViewer": "wIT-j",
  "mouseDown": "AzoJh",
  "innerEditor": "_5R852",
  "item": "_4EUcT",
  "floatingAddPluginMenuWrapper": "_1TGhI"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
